/**
 * @file Shared numeric parsing for quotation / pricing helpers.
 * Description: Coerces form/API values to a finite number or null (empty / invalid → null).
 * Inputs: any scalar from inputs
 * Output: finite number, or null
 */

export default function toOptNumber(value) {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
